import React from "react";
import cartoes from '../../assets/images/cartoes.png'
import './styles.css';

export class Plano extends React.Component {
    render() {
        return (
            <>
                <div className="plano_content">
                    <div className="plano_titulo">

                        <h3>NOVO MARATONA VOCAL</h3>
                        <h3>{this.props.tituloPlano}</h3>
                    </div>
                    <h4>de R$ <span className="line-through">{this.props.valorAntigo}</span> por:</h4>
                    <h2>12x {this.props.valorAtual}</h2>

                    <div className="plano_informacoes">
                        <p>no cartão de crédito ou R$ {this.props.aVista} à vista <span className="destaque">+</span> mais 100 aulas</p>
                        <p>Leva Novo Maratona Vocal <span className="destaque">+</span> Bônus <span className="destaque">+</span> Certificado</p>
                        <h6 className="uppercase">{this.props.textoFinal}</h6>
                    </div>

                    <a className="btn btn-hover btn-plano" href={this.props.linkPlano}
                            /*
                            onClick={() => {
                                if (window.fbq) {
                                    window.fbq('track', 'Lead'); // Rastreia o evento de lead no clique
                                }
                            }}
                            */ >{this.props.textoBotao}</a>
                    <ul className="">
                        <li className="compra-segura">
                            <span className="fa-solid fa-lock"></span>
                            <span className="compra-segura-texto">COMPRA SEGURA</span>
                        </li>
                    </ul>
                    <img className="plano-cartoes-img" src={cartoes} alt="Bandeiras de cartões" />
                </div>
            </>
        );
    }
}